document.addEventListener("DOMContentLoaded", function(){

    let thumbSlider; // Declare in outer scope for later access

    // Check if main slider elements exist before initialization
    if (document.querySelector('.slider-for')) {
        const mainSlider = new Splide('.slider-for', {
          perPage: 1,
          perMove: 1,
          arrows: false,
          type: 'fade',
          pagination: false,
          breakpoints: {
            991: {
              pagination: true,
            }
          }
        });

        mainSlider.on('moved', function(){
          const productTitle = document.querySelector('.product__title')?.textContent.trim();
          const productUrl = window.location.href;
          const eventData = {
            "Product URL": productUrl,
            "Product name": productTitle
          };
          clevertap.event.push('PDP_Image_Interaction', eventData);
        });

        thumbSlider = new Splide('.slider-nav', {
          perPage: 4,
          perMove: 1,
          pagination: false,
          isNavigation: true,
        });

        mainSlider.sync(thumbSlider);
        mainSlider.mount();
        thumbSlider.mount();
    }

    // Check if blog slider exists before initialization
    if (document.querySelector('.slider_wrap_blog')) {
        new Splide('.slider_wrap_blog', {
            type: 'loop',
            speed: 500,
            autoplay: true,
            interval: 3000,
            pagination: false,
            arrows: false,
            perPage: 1,
            perMove: 1,
        }).mount();
    }

    // Check if featured slider exists before initialization
    if (document.querySelector('.slider-featured')) {
        new Splide('.slider-featured', {
            type: 'loop',
            speed: 500,
            perPage: 2,
            perMove: 1,
            breakpoints: {
                480: {
                    perPage: 1,
                    perMove: 1
                }
            }
        }).mount();
    }

    // Check if Fancybox elements exist before binding
    // if (document.querySelector(".product-theme .slider.slider-for .splide__slide .product__media a")) {
    //     Fancybox.bind(".product-theme .slider.slider-for .splide__slide .product__media a");
    // }

    // Check if deferred media elements exist before adding event listeners
    if (document.querySelector('.slider-nav .splide__slide .deferred-media')) {
        document.querySelectorAll('.slider-nav .splide__slide .deferred-media').forEach(function(element) {
            element.addEventListener('click', function(e) {
                document.querySelector('.slider-for .deferred-media__poster')?.click();
            });
        });
    }

    // Check if slide navigation elements exist before adding event listeners
    // Get all slides as a real array
    var arraySlides = Array.from(document.querySelectorAll('.splide__slide'));

    if (
      arraySlides.some(el => el.querySelector('deferred-media')) && 
      document.querySelector('a[data-slide]')
    ) {
      document.querySelectorAll('a[data-slide]').forEach(function(element) {
        element.addEventListener('click', function(e) {
          e.preventDefault();
          var slideno = parseInt(this.dataset.slide, 10);

          // Only call thumbSlider.go if thumbSlider exists
          if (typeof thumbSlider !== 'undefined' && thumbSlider) {
            thumbSlider.go(slideno);
          }

          document
            .querySelector('.slider-for .deferred-media__poster')
            ?.click();
        });
      });
    }
  });


class ProductModal extends ModalDialog {
  constructor() {
    super();
  }

  hide() {
    super.hide();
    window.pauseAllMedia();
  }

  show(opener) {
    super.show(opener);
    this.showActiveMedia();
  }

  showActiveMedia() {
    this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
        element.classList.remove('active');
      }
    )
    const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
    activeMedia.classList.add('active');
    activeMedia.scrollIntoView();

    const container = this.querySelector('[role="document"]');
    container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

    if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
      activeMedia.loadContent();
  }
}

customElements.define('product-modal', ProductModal);

// QuantityInput sync
const desktopQty = document.querySelector('.product-form__quantity-desktop input[name="quantity"]');
const mobileQty = document.querySelector('.product-form__quantity input[name="quantity"]');

if (desktopQty && mobileQty) {
  desktopQty.addEventListener('change', () => mobileQty.value = desktopQty.value);
  mobileQty.addEventListener('change', () => desktopQty.value = mobileQty.value);
}